import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';

export const mainGrid = css`
  min-height: 100vh;
  ${media('>=tablet')} {
    display: grid;
    gap: 0px;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      'header'
      'body'
      'footer';
  }
`;

export const mainGridHeader = css`
  grid-area: header;
`;

export const mainGridBody = css`
  justify-self: center;
  grid-area: body;
  width: 100%;
`;

export const mainGridFooter = css`
  grid-area: footer;
`;

export const bodyGrid = css`
  max-width: 800px;
  padding: 10px;
  margin-left: auto;
  margin-right: auto;

  ${media('>=tablet')} {
    max-width: 1100px;
    display: grid;
    grid-gap: 10px;
    grid-template-areas:
      'breadcrumbs breadcrumbs breadcrumbs'
      'menu main main';
    grid-template-columns: 180px 1fr 1fr;
  }
  ${media('>=desktop')} {
    max-width: 1300px;
    grid-template-areas:
      'breadcrumbs breadcrumbs breadcrumbs'
      'menu main main';
    grid-template-columns: 300px 1fr 1fr;
  }
`;

export const bodyGridBreadcumbs = css`
  grid-area: breadcrumbs;
`;

export const bodyGridMenu = css`
  grid-area: menu;
  margin-bottom: 136px;
`;

export const bodyGridContent = css`
  grid-area: main;
  padding-bottom: 140px;
`;
